/**
 * Consistent user-facing message from axios / API errors.
 *
 * @param {unknown} error
 * @param {string} [fallback]
 * @returns {string}
 */
export function getApiErrorMessage(error, fallback = 'Something went wrong.') {
  const msg =
    error?.response?.data?.message ??
    error?.response?.data?.error ??
    error?.message;
  if (typeof msg === 'string' && msg.trim() !== '') return msg;
  return fallback;
}
